import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { useNavigate } from "react-router-dom"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"

export default function RaceToRiches() {
  const navigate = useNavigate()
  const data = promotionsData.find((promo) => promo.title === "Race to Riches")

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  // Table Data Incase
  const tableData = [
    {
      ranking: "1",
      noWinners: "1",
      freeSpin: "100",
      rollover: "3x",
      betValue: "₱5",
    },
    {
      ranking: "2",
      noWinners: "1",
      freeSpin: "80",
      rollover: "3x",
      betValue: "₱5",
    },
    {
      ranking: "3",
      noWinners: "1",
      freeSpin: "50",
      rollover: "3x",
      betValue: "₱5",
    },
    {
      ranking: "4",
      noWinners: "1",
      freeSpin: "40",
      rollover: "3x",
      betValue: "₱5",
    },
    {
      ranking: "5",
      noWinners: "1",
      freeSpin: "30",
      rollover: "3x",
      betValue: "₱5",
    },
    {
      ranking: "6-20",
      noWinners: "15",
      freeSpin: "20",
      rollover: "3x",
      betValue: "₱5",
    },
    {
      ranking: "21-40",
      noWinners: "20",
      freeSpin: "15",
      rollover: "3x",
      betValue: "₱5",
    },
    {
      ranking: "41-50",
      noWinners: "10",
      freeSpin: "10",
      rollover: "3x",
      betValue: "₱5",
    },
  ]

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Race to Riches</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>JILI Slots : Race to Riches</h1>
                <h2>More Spins, Bigger Wins Every Week!</h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period : </strong>
                  <span>April 01 (12NN) - April 29 (11:59AM), 2025</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong>Mechanics : </strong>
                <ol>
                  <li>
                    Play any JILI Slots Game from Tuesday 12 NOON to 11:59 AM
                    next Tuesday.
                  </li>
                  <li>
                    The Top 50 players with the highest number of spins each
                    week (1 spin = 1 point) will win FREE SPINS as follows:
                    <span className="promotion-tnc-block-text">
                      (Fishing, Specialty and Table Games are not included in
                      this promo).
                    </span>
                    <div className="table-wrapper">
                      <table className="promotion-tnc-table">
                        <thead>
                          <th>Ranking</th>
                          <th>No. Winners</th>
                          <th>Free Spin</th>
                          <th>Rollover</th>
                          <th>Bet Value Per Free Spin</th>
                        </thead>
                        <tbody>
                          {tableData.map((row, index) => (
                            <tr key={index}>
                              <td>{row.ranking}</td>
                              <td>{row.noWinners}</td>
                              <td>{row.freeSpin}</td>
                              <td>{row.rollover}</td>
                              <td>{row.betValue}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </li>
                  <li>
                    Leaderboard will be updated every 5 mins and will reset
                    weekly on Tuesday 12 NN.
                  </li>
                  <li>No minimum bet amount is required to participate.</li>
                  <li>
                    Winners will receive respective FREE SPINS every Tuesday
                    5PM.
                  </li>
                  <li>
                    Winnings from FREE SPINS awarded has 1x rollover before any
                    withdrawal.
                  </li>
                  <li>
                    FGH reserves the right to modify, suspend or cancel the
                    promotion at any time.
                  </li>
                </ol>
                <div className="promotion-tnc-cta">
                  <a href="/slots/?provider=JILI" className="promotion-cta-btn">
                    Play Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
